import { call, put, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  GET_ALL_ENROLLMENTS,
  GET_ALL_ENROLLMENTS_SUCCESS,
  GET_ALL_ENROLLMENTS_ERROR,
  initialState as allEnrollmentsInitialState,
  RESET_GET_ALL_ENROLLMENTS
} from "../types/enrollment/get-all.dto";

import {
  GET_ONE_ENROLLMENT,
  GET_ONE_ENROLLMENT_SUCCESS,
  GET_ONE_ENROLLMENT_ERROR,
  initialState as oneEnrollmentInitialState,
  RESET_GET_ONE_ENROLLMENT
} from "../types/enrollment/get-one.dto";

import {
  UPDATE_ENROLLMENT,
  UPDATE_ENROLLMENT_SUCCESS,
  UPDATE_ENROLLMENT_ERROR,
  initialState as updateEnrollmentInitialState,
  RESET_UPDATE_ENROLLMENT
} from "../types/enrollment/update.dto";

import {
  NEW_ENROLLMENT,
  NEW_ENROLLMENT_SUCCESS,
  NEW_ENROLLMENT_ERROR,
  initialState as newEnrollmentInitialState,
  RESET_NEW_ENROLLMENT
} from "../types/enrollment/new.dto";

function* createOneEnrollment({ payload }) {
  try {
    const { response, error } = yield call(services.enrollment.new, payload);

    if (error) {
      yield put({ type: NEW_ENROLLMENT_ERROR, payload: error });
    } else {
      yield put({
        type: NEW_ENROLLMENT_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: NEW_ENROLLMENT_ERROR,
      payload: "Error al iniciar el curso",
    });
  }
}

function* getAllEnrollments({ payload }) {
  try {
    const { response, error } = yield call(services.enrollment.getAll, payload);

    if (error) {
      yield put({ type: GET_ALL_ENROLLMENTS_ERROR, payload: error });
    } else {
      yield put({
        type: GET_ALL_ENROLLMENTS_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: GET_ALL_ENROLLMENTS_ERROR,
      payload: "Error al obtener cursos",
    });
  }
}

function* updateEnrollments({ payload }) {
  try {
    const { response, error } = yield call(services.enrollment.update, payload);

    if (error) {
      yield put({ type: UPDATE_ENROLLMENT_ERROR, payload: error });
    } else {
      yield put({
        type: UPDATE_ENROLLMENT_SUCCESS,
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: UPDATE_ENROLLMENT_ERROR,
      payload: "Error al actualizar cursos",
    });
  }
}

function* getOneEnrollment({ payload }) {
  try {
    const { response, error } = yield call(services.course.getOne, payload);

    if (error) {
      yield put({ type: GET_ONE_ENROLLMENT_ERROR, payload: error });
    } else {
      yield put({ type: GET_ONE_ENROLLMENT_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({
      type: GET_ONE_ENROLLMENT_ERROR,
      payload: "Error al obtener curso",
    });
  }
}

function* resetNewEnrollment() {
  try {
    yield put({
      type: NEW_ENROLLMENT_SUCCESS,
      payload: newEnrollmentInitialState,
    });
  } catch (error) {
    console.log("error al reiniciar store del curso")
  }
}

function* resetUpdateEnrollment() {
  try {
    yield put({
      type: UPDATE_ENROLLMENT_SUCCESS,
      payload: updateEnrollmentInitialState,
    });
  } catch (error) {
    console.log("error al reiniciar store del curso")
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_ALL_ENROLLMENTS, getAllEnrollments);
  yield takeLatest<any>(NEW_ENROLLMENT, createOneEnrollment);
  yield takeLatest<any>(UPDATE_ENROLLMENT, updateEnrollments);
  yield takeLatest<any>(GET_ONE_ENROLLMENT, getOneEnrollment);

  yield takeLatest<any>(RESET_GET_ONE_ENROLLMENT, resetUpdateEnrollment);
  yield takeLatest<any>(RESET_GET_ALL_ENROLLMENTS, resetNewEnrollment);
}
